/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_2_TInputs */

const en_tut_part_2_t = /** @type {(inputs: Tut_Part_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyday work`)
};

const id_tut_part_2_t = /** @type {(inputs: Tut_Part_2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan sehari-hari`)
};

/**
* | output |
* | --- |
* | "Everyday work" |
*
* @param {Tut_Part_2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_2_t = /** @type {((inputs?: Tut_Part_2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_2_t(inputs)
	return en_tut_part_2_t(inputs)
});